import store from "@/store";

export function extractEntityContext(route) {
  const tenant = store.getters["tenant/tenant"];
  const { name, params } = route;

  // Organizer public site (subdomain)
  // Tenant context ALWAYS wins
  if (tenant) {
    return {
      entityType: "organizer",
      entityId: tenant.normalized?.id || null,
      funnelStep: "trust",
    };
  }

  // Event details page
  if (name === "event-details" && params.id) {
    return {
      entityType: "event",
      entityId: params.id,
      funnelStep: "view",
    };
  }

  // Event registration (checkout)
  if (name === "event-register" && params.id) {
    return {
      entityType: "event",
      entityId: params.id,
      funnelStep: "register",
    };
  }

  // Ticket review (post-purchase)
  if (name === "viewTicket" && params.id) {
    return {
      entityType: "ticket",
      entityId: params.id,
      funnelStep: "post_purchase",
    };
  }

  // Search results
  if (name === "search-results") {
    return {
      entityType: "search",
      funnelStep: "discover",
    };
  }

  // Discover feed
  if (name === "discover") {
    return {
      entityType: "discover",
      funnelStep: "discover",
    };
  }

  // Home page
  if (name === "Home") {
    return {
      entityType: "home",
      funnelStep: "discover",
    };
  }

  return {};
}
